
import dayjs from 'dayjs';
import { Component, Prop, Mixins } from 'vue-property-decorator';
import LoadableMixin from '@/mixins/LoadableMixin';
import ModelMixin from '@/mixins/ModelMixin';
import ValidateableMixin from '@/mixins/ValidateableMixin';
import Gravatar from 'vue-gravatar';
import { DeviceInfo, SharedDeviceInfo, ACCESS_LEVEL_LIMITED } from '@/types/device-info';
import { PRIVILEGES_LIMITED, PRIVILEGES_OPTIONS, SECURITY_OPTIONS } from '@/utils/constants';
import rules from '@/utils/validation-rules';
import DeviceSettingsShareMenu from '@/components/devices/menus/DeviceSettingsShareMenu.vue';

@Component({
    components: { Gravatar, DeviceSettingsShareMenu },
    mixins: [LoadableMixin, ModelMixin, ValidateableMixin],
})
export default class ShareEditPopup extends Mixins<LoadableMixin, ModelMixin<SharedDeviceInfo>, ValidateableMixin>(
    LoadableMixin,
    ModelMixin,
    ValidateableMixin,
) {
    menu = false;
    privilegesOptions = PRIVILEGES_OPTIONS;
    securityOptions = SECURITY_OPTIONS;

    @Prop({ required: true })
    device!: DeviceInfo;

    @Prop({ required: false })
    title!: string;

    @Prop({ required: true })
    onSave!: (share: SharedDeviceInfo) => void;

    @Prop({ required: false })
    onResendShare!: (share: SharedDeviceInfo) => void;

    @Prop({ required: false })
    onRemove!: (share: SharedDeviceInfo) => void;

    @Prop({ required: false })
    onRemoveListShare!: (share: SharedDeviceInfo) => void;

    @Prop({ required: false })
    onEdit!: (share: SharedDeviceInfo) => void;

    @Prop({ required: true })
    showFullForm!: boolean;

    @Prop({ required: false })
    shares!: SharedDeviceInfo[];

    @Prop({ required: false })
    tableLoading!: boolean;

    get emailRules() {
        return [rules.required('This field is required'), rules.email('Value must be valid email address')];
    }

    get requiredRules() {
        return [rules.required('This field is required')];
    }

    get expiryDate() {
        return dayjs(this.model.expiryDate).format('DD/MM/YYYY');
    }

    get strExpiryDate() {
        return dayjs(this.model.expiryDate).toISOString();
    }

    set strExpiryDate(value: string) {
        this.model.expiryDate = dayjs(value).hour(0).minute(0).toDate();
    }

    get showExpiryDate() {
        return this.model.accessRightsFlag === PRIVILEGES_LIMITED;
    }

    validateForm() {
        if (!this.model.securityLevel) return false;
        if (!this.model.accessRightsFlag) return false;
        return true;
    }

    save(e: Event) {
        e.preventDefault();
        if (
            !this.model._id &&
            !(
                this.showFullForm ||
                (this.device.shares != undefined && this.device.shares.length === 0) ||
                (this.device.share_count != undefined && this.device.share_count === 0)
            )
        ) {
            this.showFullForm = true;
            return;
        }
        // if (!this.validateForm()) {
        //     return Vue.toasted.error(`Please select all fields`);
        // }
        // if (!this.validate()) {
        //     return;
        // }
        if (this.onSave) {
            this.onSave(this.model);
        }
    }
    resend() {
        this.onResendShare(this.model);
    }
    resendListShare(share: SharedDeviceInfo) {
        this.onResendShare(share);
    }
    remove() {
        this.onRemove(this.model);
    }
    removeListShare(share: SharedDeviceInfo) {
        this.onRemoveListShare(share);
    }
    async edit(share: SharedDeviceInfo) {
        this.onEdit(share);
    }
    accepted(share: SharedDeviceInfo) {
        return !!share.isAcceptedFlag;
    }
    expiresIn(share: SharedDeviceInfo) {
        if (share.accessRightsFlag === ACCESS_LEVEL_LIMITED) {
            return `Until ${dayjs(share.expiryDate).format('DD/MM/YYYY h:mm A')}`;
        }

        return '-';
    }
}
